import { useState } from 'react';

export const useUIState = () => {
  const [showStartScreen, setShowStartScreen] = useState(false);
  const [skipStartScreen, setSkipStartScreen] = useState(false);
  
  // Menu states
  const [menuPopup, setMenuPopup] = useState({
    isOpen: false,
    type: null,
    data: null,
    navigationStack: []
  });
  
  // Item details popup
  const [itemDetailsPopup, setItemDetailsPopup] = useState({
    isOpen: false,
    data: null
  });
  
  // Confirmation dialog state
  const [confirmation, setConfirmation] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: null
  });

  const handleMenuItemClick = (menuType) => {
    setMenuPopup({
      isOpen: true,
      type: menuType,
      data: null,
      navigationStack: []
    });
  };

  const handleCloseMenu = () => {
    setMenuPopup({
      isOpen: false,
      type: null,
      data: null,
      navigationStack: []
    });
  };

  const handleMenuNavigation = (newType, data = null) => {
    setMenuPopup(prev => ({
      isOpen: true,
      navigationStack: [...prev.navigationStack, { type: prev.type, data: prev.data }],
      type: newType,
      data
    }));
  };

  const handleMenuBack = () => {
    setMenuPopup(prev => {
      if (prev.navigationStack.length === 0) {
        return {
          isOpen: false,
          type: null,
          data: null,
          navigationStack: []
        };
      }
      const previous = prev.navigationStack[prev.navigationStack.length - 1];
      return {
        ...prev,
        type: previous.type,
        data: previous.data,
        navigationStack: prev.navigationStack.slice(0, -1)
      };
    });
  };

  const handleShowItemDetails = (data) => {
    setItemDetailsPopup({
      isOpen: true,
      data
    });
  };

  const handleCloseItemDetails = () => {
    setItemDetailsPopup({
      isOpen: false,
      data: null
    });
  };

  const handleShowConfirmation = (title, message, onConfirm) => {
    setConfirmation({
      isOpen: true,
      title,
      message,
      onConfirm
    });
  };

  const handleCloseConfirmation = () => {
    setConfirmation({
      isOpen: false,
      title: '',
      message: '',
      onConfirm: null
    });
  };

  return {
    showStartScreen,
    setShowStartScreen,
    skipStartScreen,
    setSkipStartScreen,
    menuPopup,
    itemDetailsPopup,
    confirmation,
    handleMenuItemClick,
    handleCloseMenu,
    handleMenuNavigation,
    handleMenuBack,
    handleShowItemDetails,
    handleCloseItemDetails,
    handleShowConfirmation,
    handleCloseConfirmation
  };
};